/* Native Shopify language POST, progressively enhanced with a keyboard menu. */
(() => {
  'use strict';
  if (window.__r25LanguagePicker) return;
  window.__r25LanguagePicker = true;
  const instances = new Set();
  function init(root = document) {
    const nodes = [...root.querySelectorAll('[data-r25-language]')];
    if (root.matches?.('[data-r25-language]')) nodes.push(root);
    nodes.forEach(node => {
      if (node.hasAttribute('data-r25-ready')) return;
      const form = node.querySelector('form');
      const select = form?.querySelector('select[name="language_code"]');
      const trigger = node.querySelector('.r25-language__trigger');
      const panel = node.querySelector('[role="menu"]');
      const choices = [...node.querySelectorAll('[data-r25-language-code]')];
      if (!form || !select || !trigger || !panel || !choices.length) return;
      const initialCode = select.value;
      let closeTimer, typeTimer, letters = '', isOpen = false, submitting = false;
      const focus = index => choices[(index + choices.length) % choices.length].focus();
      const close = restore => {
        if (!isOpen) return;
        isOpen = false;
        node.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.inert = true;
        if (restore) trigger.focus();
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => { if (!isOpen) panel.hidden = true; }, 170);
      };
      const entry = { node, close };
      instances.add(entry);
      const open = keyboard => {
        if (submitting) return;
        instances.forEach(other => { if (other !== entry) other.close(false); });
        clearTimeout(closeTimer);
        node.toggleAttribute('data-keyboard', keyboard);
        isOpen = true;
        panel.hidden = false;
        panel.inert = false;
        trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          if (!isOpen) return;
          node.setAttribute('data-open', '');
          if (keyboard) focus(Math.max(0, choices.findIndex(button => button.dataset.r25LanguageCode === select.value)));
        });
      };
      trigger.hidden = false;
      node.setAttribute('data-r25-ready', '');
      trigger.addEventListener('click', event => isOpen ? close(false) : open(event.detail === 0));
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        open(true);
      });
      node.addEventListener('keydown', event => {
        if (!isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation(); // Keep the enclosing mobile navigation open.
          close(true);
          return;
        }
        if (event.key === 'Tab') return; // Native focus order; focusout closes after focus has moved.
        if (!panel.contains(event.target)) return;
        const current = choices.indexOf(event.target.closest('[data-r25-language-code]'));
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          focus(event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : current + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey && event.key !== ' ') {
          letters += event.key.toLocaleLowerCase();
          clearTimeout(typeTimer);
          typeTimer = setTimeout(() => { letters = ''; }, 600);
          const ordered = choices.slice(current + 1).concat(choices.slice(0, current + 1));
          const found = ordered.find(button => button.textContent.trim().toLocaleLowerCase().startsWith(letters));
          if (found) { event.preventDefault(); found.focus(); }
        }
      });
      choices.forEach(button => button.addEventListener('click', () => {
        if (submitting) return;
        const code = button.dataset.r25LanguageCode;
        if (code === select.value) { close(true); return; }
        if (![...select.options].some(option => option.value === code)) return;
        select.value = code;
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
        submitting = true;
        node.setAttribute('aria-busy', 'true');
        close(true);
        try { form.requestSubmit(); } catch (_) {
          submitting = false;
          node.removeAttribute('aria-busy');
          node.removeAttribute('data-r25-ready');
          trigger.hidden = true; // A usable native form survives any enhancement failure.
        }
      }));
      node.addEventListener('focusout', event => { if (!node.contains(event.relatedTarget)) close(false); });
      node._r25Reset = () => { submitting = false; select.value = initialCode; node.removeAttribute('aria-busy'); close(false); };
    });
  }
  document.addEventListener('pointerdown', event => instances.forEach(({ node, close }) => { if (!node.contains(event.target)) close(false); }));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach(entry => { if (event.target.contains(entry.node)) { entry.close(false); instances.delete(entry); } }));
  window.addEventListener('pageshow', event => { if (event.persisted) instances.forEach(({ node }) => node._r25Reset?.()); });
  init();
})();
